import { useEffect, useState } from 'react'
import { imageUrl } from 'app/frontend/base/helpers'
import { usePageInfo } from 'app/frontend/base/config/queries'

export const useEncounterImage = (
  encounterId: number | undefined,
  index: number,
) => {
  const {
    data: { currentExpansion },
  } = usePageInfo()
  const [image, setImage] = useState<HTMLImageElement>()
  useEffect(() => {
    setImage(undefined)
    if (encounterId === undefined) return
    const names: string[] | undefined = currentExpansion.seasons
      .flatMap((season) => season.instances)
      .flatMap((instance) => instance.encounters)
      .find((encounter) => encounter.id === encounterId)?.encounterAreaImages
    const name = names?.[index]
    const file = name ? `${index}-${name}.webp` : `${index}.webp`
    const element = new window.Image()
    element.src = imageUrl(`encounter-areas/${encounterId}/${file}`)
    const handleLoad = () => setImage(element)
    element.addEventListener('load', handleLoad)
    return () => element.removeEventListener('load', handleLoad)
  }, [encounterId, index, currentExpansion])
  return image
}
